import { Link } from "react-router-dom";
import { articles } from "@/mocks/articles";

export default function HotTicker() {
  const ranked = [...articles].sort((a, b) => b.hot - a.hot);
  const doubled = [...ranked, ...ranked];

  return (
    <section
      aria-label="实时热瓜滚动"
      className="w-full bg-primary-500 text-background-50"
    >
      <div className="flex items-center">
        <div className="shrink-0 flex items-center gap-2 px-4 md:px-6 h-12 bg-primary-600">
          <i className="ri-flashlight-fill text-accent-300" aria-hidden="true"></i>
          <span className="text-sm font-medium whitespace-nowrap">实时热瓜</span>
        </div>
        <div className="relative flex-1 overflow-hidden h-12">
          <div className="animate-ticker flex items-center h-12 w-max">
            {doubled.map((article, index) => (
              <Link
                key={`${article.id}-${index}`}
                to={`/article/${article.id}`}
                className="inline-flex items-center text-sm whitespace-nowrap hover:text-accent-200 transition-colors cursor-pointer"
              >
                <span className="text-accent-200 mr-2">
                  #{index % ranked.length + 1}
                </span>
                {article.title}
                <span className="mx-6 text-background-50/40">·</span>
              </Link>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}